import {
  Box,
  CircularProgress,
  TablePagination,
  Typography,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { ImageContainer } from "../../shared/components/ImageContainer";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toastSuccess } from "../../utils/ToastMessage";
import { FigmaIcon } from "../../assets/icons/icons";
import { LockIconSvg } from "../../assets/icons/LockIconSvg";
import Chip from "../../shared/components/Chip";
import ReportCard from "./components/ReportCard";
import { useEffect, useState } from "react";
import { getAllReports, getComponentById, updateComponent } from "../../services/component";
import React from "react";
import { ButtonPrimary } from "../../shared/components/button/Buttons";
import { colors } from "../../utils/colors";
import { monthStringFormatDate } from "../../utils/extensions";
import { FRONTEND_HOST_NAME } from "../../utils/constants";
import { CustomTabs } from "../../shared/components/CustomTabs";
import { updatePage } from "../../services/page";
import { updateScreen } from "../../services/screen";

type Props = {};

const ReportDeailScreen = (props: Props) => {
  const tableRef = React.createRef<any>();
  const navigate = useNavigate();
  const location = useLocation();
  const { rowData, value } = location.state || {}; // Retrieve id from location state

  // current page and rows per page handling states and functions
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [loading, setLoading] = useState<boolean>(true);
  const [reportsTabValue, setReportsTabValue] = useState<number>(0);

  // Tabs for reports status "Open", "In Progress", "Resolved", "Irrelevant",
  const tabs = [
    { label: "Open", value: 0 },
    { label: "In Progress", value: 1 },
    { label: "Resolved", value: 2 },
    { label: "Irrelevant", value: 3 },
  ];

  const filteredReports = rowData?.problems?.filter(
    (report: any) =>
      report.status?.toLowerCase() === tabs[reportsTabValue].label.toLowerCase()
  );

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setReportsTabValue(newValue);
    setPage(0);
  };

  const handleCopyFigmaCode = () => {
    const htmlContent = rowData?.figmaCode;
    // Create a Blob with the HTML content and specify the MIME type as 'text/html'
    const blob = new Blob([htmlContent], { type: "text/html" });
    const clipboardItem = new ClipboardItem({ "text/html": blob });
    // Copy the Blob to the clipboard
    navigator.clipboard
      .write([clipboardItem])
      .then(() => {
        toastSuccess("Successfull", "Component is copied");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const handleUnpublish = async () => {
      const id = rowData?.id;
      const dataToUpdate = { status: "INACTIVE" };
  
      try {
        if (value === 0) {
          await updateComponent(id, dataToUpdate, []);
        } else if (value === 1) {
          await updatePage(id, dataToUpdate, []);
        } else if (value === 2) {
          await updateScreen(id, dataToUpdate, []);
        }
        toastSuccess("Success", "Data unpublished successfully!");
      } catch (error) {
        console.error("Unpublish failed:", error);
      }
    };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // const handleChangeRowsPerPage = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   tableRef.current && tableRef.current.scrollIntoView();
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  useEffect(() => {}, [rowData]);

  useEffect(() => {
    if (rowData) {
      setLoading(false);
    }
  }, [rowData]);

  // Manual pagination for particular data problems
  const paginatedReports = filteredReports?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // making url for reported data
  const dynamicPathSegment =
    value === 0 ? "component" : value === 1 ? "page" : "screen";
  const dynamicUrl = `${FRONTEND_HOST_NAME}/${dynamicPathSegment}/${rowData?.blurbUrl}`;

  // Link for edit the data with edit button
  const editBasePath =
    value === 0
      ? "/product/component/edit"
      : value === 1
      ? "/page/edit"
      : "/screen/edit";

  const editUrl = `${editBasePath}/${rowData?.id}`;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      {/* Main Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "40px 80px 80px 80px",
        }}
      >
        {/* ------Content detail section------ */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "32px",
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "600" }} variant="h4">
              {rowData?.title}
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ color: "rgba(255, 255, 255, 0.5)", fontWeight: "400" }}
            >
              {rowData?.blurb}
            </Typography>
            <Typography
              component="a"
              href={dynamicUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="h4"
              sx={{
                color: "#FFFFFF",
                fontWeight: "600",
                position: "absolute",
                right: "0",
                fontSize: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <OpenInNewIcon sx={{ fontSize: 22, mr: 1 }} />
              Link
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "38px",
            }}
          >
            {/* ----Preview Image---- */}

            <Box
              sx={{
                // width: "fit-content",
                // height: "fit-content",
                // flex: 1,
                width: "100%",
                maxWidth: "900px",
                flexDirection: "column",
                display: "flex",
                gap: "16px",
              }}
            >
              <Box
                sx={{
                  // flex: 1,
                  width: "100%",
                  borderRadius: "14px",
                  bgcolor: "#1B1B1B",
                  aspectRatio: "3/2",
                  overflow: "hidden",
                }}
              >
                {loading ? (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress
                      style={{ color: "white", width: "24px", height: "24px" }}
                    />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      // flex: 1,
                      width: "100%",
                      height: "100%",
                      borderRadius: "14px",
                      backgroundImage:
                        value === 0
                          ? rowData?.documents?.[0]?.previewURL
                            ? `url(${rowData?.documents[0]?.previewURL})`
                            : ""
                          : rowData?.thumbnailUrl
                          ? `url(${rowData?.thumbnailUrl})`
                          : "",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      aspectRatio: "3/2",
                    }}
                  ></Box>
                )}
              </Box>
            </Box>

            {/* -----Details----- */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                // maxWidth: "338px",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              {/* ---Figma--- */}
              <Box
                onClick={(e: any) => {
                  e.preventDefault();
                  if (Cookies.get("jstoken")) {
                    handleCopyFigmaCode();
                  }
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  bgcolor: "#1B1B1B",
                  boxShadow: "inset 0px 0px 0px 1px #3D3D3D",
                  borderRadius: "14px",
                  justifyContent: "space-between",
                  padding: "15px",
                  cursor: "pointer",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <ImageContainer
                    style={{ width: "24px", height: "24px" }}
                    title="figma"
                  >
                    {FigmaIcon}
                  </ImageContainer>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "rgba(255, 255, 255, 0.5)",
                      fontWeight: "400",
                    }}
                  >
                    Figma
                  </Typography>
                </Box>
              </Box>

              {/* ---Overview--- */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "12px",
                  bgcolor: "#1B1B1B",
                  boxShadow: "inset 0px 0px 0px 1px #3D3D3D",
                  borderRadius: "14px",
                  justifyContent: "space-between",
                  padding: "24px",
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontWeight: "600",
                  }}
                  variant="h4"
                >
                  Overview
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(255, 255, 255, 0.5)",
                    fontWeight: "400",
                    lineHeight: "24px",
                  }}
                  variant="body1"
                >
                  {rowData?.description}
                </Typography>
              </Box>

              {/* ------Product Description------ */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "12px",
                  bgcolor: "#1B1B1B",
                  boxShadow: "inset 0px 0px 0px 1px #3D3D3D",
                  borderRadius: "14px",
                  justifyContent: "space-between",
                  padding: "24px",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontWeight: "600",
                  }}
                  variant="h4"
                >
                  Product Description
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "rgba(255, 255, 255, 0.5)",
                        fontWeight: "400",
                      }}
                      variant="body1"
                    >
                      Category
                    </Typography>

                    <Typography
                      sx={{
                        color: "white",
                        fontWeight: "400",
                      }}
                      variant="body1"
                    >
                      {rowData?.category || "-"}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "rgba(255, 255, 255, 0.5)",
                        fontWeight: "400",
                      }}
                      variant="body1"
                    >
                      Release
                    </Typography>

                    <Typography
                      sx={{
                        color: "white",
                        fontWeight: "400",
                      }}
                      variant="body1"
                    >
                      {monthStringFormatDate(rowData?.createdAt) || "-"}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "rgba(255, 255, 255, 0.5)",
                        fontWeight: "400",
                      }}
                      variant="body1"
                    >
                      Author
                    </Typography>

                    <Typography
                      sx={{
                        color: "white",
                        fontWeight: "400",
                      }}
                      variant="body1"
                    >
                      UI Wiki
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  mt: "16px",
                }}
              >
                {rowData && (
                  <ButtonPrimary
                    onClick={() => {
                      // navigate(`/product/component/edit/${rowData?.id}`, {
                      navigate(editUrl, {
                        state: {
                          data: [rowData],
                        },
                      });
                    }}
                    sx={{
                      width: "100%",
                    }}
                    label="Edit"
                  />
                )}
                <ButtonPrimary
                  onClick={handleUnpublish}
                  sx={{
                    width: "100%",
                    backgroundColor: colors.primaryRed,
                    color: "white",
                    ":hover": {
                      backgroundColor: colors.primaryRed,
                    },
                  }}
                  label="Unpublish"
                />
              </Box>

              {/* ------Tags------ */}
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                {rowData?.tags?.map((tag: string, index: number) => {
                  return <Chip key={index} index={index} title={tag} />;
                })}
              </Box>
            </Box>
          </Box>

          {/* ------Tabs------ */}
          <CustomTabs
            tabs={tabs}
            value={reportsTabValue}
            onChange={handleChange}
          />

          {/* ------Reports------ */}
          {!loading ? (
            rowData?.problems?.length > 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  gap: "24px",
                }}
              >
                {paginatedReports.map((report: any) => {
                  return <ReportCard key={report.id} data={report} />;
                })}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <TablePagination
                    labelRowsPerPage="Showing"
                    SelectProps={{
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      style: {
                        fontWeight: "700",
                      },
                    }}
                    sx={{
                      "& .MuiTablePagination-selectLabel": {
                        fontWeight: "700",
                        color: "rgba(255, 255, 255, 0.24)",
                        marginRight: "5px",
                      },
                      "& .MuiTablePagination-displayedRows": {
                        color: "rgba(255, 255, 255, 0.24)",
                        fontWeight: "600",
                      },
                      "& .MuiButtonBase-root": {
                        boxShadow: "inset 0px 0px 0px 2px #3D3D3D",
                        cursor: "pointer !important",
                      },
                      "& .MuiSvgIcon-root": {
                        color: "white",
                      },
                      "& .MuiTablePagination-actions": {
                        display: "flex",
                        gap: "12px !important",
                        flex: 1,
                        justifyContent: "flex-end",
                      },
                      "&.MuiTablePagination-root": {
                        width: "100%",
                        flex: 1,
                        display: "flex",
                        justifyContent: "space-between",
                      },
                      "& .MuiTablePagination-spacer": {
                        flex: 0,
                        display: "none",
                      },
                      "& .MuiTablePagination-toolbar": {
                        flex: 1,
                        display: "flex",
                        paddingLeft: 0,
                      },
                      "& .MuiTablePagination-select": {
                        display: "none",
                      },
                      "& .MuiInputBase-root": {
                        display: "none",
                      },
                    }}
                    // rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={filteredReports?.length || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    // onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Box>
              </Box>
            ) : (
              <Typography color="white">No Reports yet</Typography>
            )
          ) : (
            <CircularProgress
              style={{
                color: "white",
                width: "24px",
                height: "24px",
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ReportDeailScreen;
